import { render } from "./FaceDeleteModal.vue?vue&type=template&id=93f24994&ts=true"
import script from "./FaceDeleteModal.vue?vue&type=script&lang=ts"
export * from "./FaceDeleteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__